import { render, staticRenderFns } from "./ParticipantDetailNav.vue?vue&type=template&id=284b3eb1&scoped=true"
import script from "./ParticipantDetailNav.vue?vue&type=script&lang=js"
export * from "./ParticipantDetailNav.vue?vue&type=script&lang=js"
import style0 from "./ParticipantDetailNav.vue?vue&type=style&index=0&id=284b3eb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284b3eb1",
  null
  
)

export default component.exports